import { LinkButton } from '@cian/ui-kit';
import { IconProductSpecialLoanRate24 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import { AuthorLabel } from '../AuthorLabel';

import styles from './BankItem.css';

export interface IBankItemProps {
  label?: string | null;
  logoUrl?: string | null;
  mortgagePartnerLink?: string | null;
  name: string;
  onMortgageClick?(): void;
}

export const BankItem: FC<IBankItemProps> = ({ label, logoUrl, mortgagePartnerLink, name, onMortgageClick }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['info']}>
        <AuthorLabel label={label} logoIcon={<IconProductSpecialLoanRate24 />} logoUrl={logoUrl} name={name} />
      </div>

      {mortgagePartnerLink && (
        <div className={styles['link']}>
          <LinkButton fullWidth href={mortgagePartnerLink} size="M" theme="fill_secondary" onClick={onMortgageClick}>
            Получить ипотеку онлайн
          </LinkButton>
        </div>
      )}
    </div>
  );
};
